// Import dependencies
import React, {Component} from 'react';
import { Router } from 'react-router';
import { Route, Switch } from "react-router-dom"
import ReactHowler from 'react-howler'

// Import css
import './App.css';

// Import components
import Landing from "./screens/Landing";
import Services from "./screens/Services";
import RequestBrochure from "./screens/RequestBrochure";
import SoundButton from "./components/global/buttons/SoundButton";
import RotateScreen from "./components/ipad/RotateScreen";
import history from './components/router/history'

// Import sounds
import main from './resources/sounds/main.mp3'
import Menu from "./screens/Menu";

// Detect ipad
const platform = require('platform');


class App extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            width: 0,
            playing: false
        };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.toggleSound = this.toggleSound.bind(this);
    }

    // Either turns sound on or off
    toggleSound()
    {
        if (this.state.playing) {
            this.player.howler.fade(1.0, 0.0, 1500);
            setTimeout(function() { this.setState({ playing: false })}.bind(this), 1500)
        }
        else {
            this.setState({ playing: true });
            this.player.howler.fade(0.0, 1.0, 1500);
        }
    }

    // Updates window dimensions on window resize event
    updateWindowDimensions()
    {
        this.setState({ width: window.innerWidth });
    }

    componentWillMount()
    {
        // Set window resize listener
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount()
    {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    render()
    {
        return (
            <div className="app__container">
                <Router history={history}>
                    <Switch>
                        <Route path="/" exact render={routeProps => <Landing {...routeProps} sound={this.state.playing}/>} />
                        <Route path="/services" exact render={routeProps => <Services {...routeProps} sound={this.state.playing}/>} />
                        <Route path="/menu" exact render={routeProps => <Menu {...routeProps} sound={this.state.playing}/>} />
                        <Route path="/request-brochure" exact render={routeProps => <RequestBrochure {...routeProps} sound={this.state.playing}/>} />
                    </Switch>
                </Router>

                {/* Toggle Sound Button */}
                <SoundButton width={this.state.width} toggleSound={this.toggleSound} />

                {/* Sound Component */}
                <ReactHowler
                    src={ main }
                    playing={ this.state.playing }
                    preload={ true }
                    loop={ true }
                    ref={(ref) => (this.player = ref)}
                    onLoad={ this.toggleSound }
                    autoUnlock={ true }
                    autoSuspend={ false }
                />

                {/* Rotate Screen for iPad */}
                {
                    platform.product === 'iPad' ||
                    platform.product === 'Kindle' ||
                    platform.product === 'Kindle Fire' ||
                    platform.product === 'Nook' ||
                    platform.product === 'PlayBook' ||
                    platform.product === 'Transformer'
                        ?
                        <RotateScreen />
                        :
                        null
                }
            </div>
        );
    }
}

export default App;
